const strings = {
  MANDATORY_FIELD: 'Fältet är oblikatoriskt',
  INFORMATION_CREATED: 'Informationen har skapats',
  INTERNAL_ERROR: 'Ett oväntat fel har uppstått, var god försök igen.',
  CREATE_INFORMATION: 'Skapa information',
  CREATE_INFORMATION_INFO: 'Fyll i fälten nedan för att skapa informationen.'
}

export default strings



// WEBPACK FOOTER //
// ./src/components/containers/NewInformationItemModal/strings.js